import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import { products, clouds } from '../../components/product.js';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Hero = makeShortcode("Hero");
const ProductCardGrid = makeShortcode("ProductCardGrid");
const DCSummaryBlock = makeShortcode("DCSummaryBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Hero slots="heading" layout="section" variant="fullwidth" customLayout className="herobgImage Hero-Banner" mdxType="Hero" />
    <h3 {...{
      "id": "adobe-document-generation-api-templates"
    }}>{`Adobe Document Generation API templates`}</h3>
    <ProductCardGrid clouds={clouds} products={products} showName={true} showDescription={false} interaction={true} buttonName="Download" showBorder={false} imgHeight="1300" isCentered={true} theme="light" className="Download-sample-templates" mdxType="ProductCardGrid" />
    <DCSummaryBlock slots="image, heading, text, buttons" theme="lightest" background="white" className="We-are-ready-to-help" mdxType="DCSummaryBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1060px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "31.69811320754717%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/96797533521002ee15b4f820d07b2740/dda86/bg-hero.webp 265w", "/document-services/static/96797533521002ee15b4f820d07b2740/010e6/bg-hero.webp 530w", "/document-services/static/96797533521002ee15b4f820d07b2740/668f0/bg-hero.webp 1060w", "/document-services/static/96797533521002ee15b4f820d07b2740/89d57/bg-hero.webp 1590w", "/document-services/static/96797533521002ee15b4f820d07b2740/4250d/bg-hero.webp 1680w"],
            "sizes": "(max-width: 1060px) 100vw, 1060px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/96797533521002ee15b4f820d07b2740/35d86/bg-hero.jpg 265w", "/document-services/static/96797533521002ee15b4f820d07b2740/7d9a0/bg-hero.jpg 530w", "/document-services/static/96797533521002ee15b4f820d07b2740/44a6b/bg-hero.jpg 1060w", "/document-services/static/96797533521002ee15b4f820d07b2740/ffe9b/bg-hero.jpg 1590w", "/document-services/static/96797533521002ee15b4f820d07b2740/e1372/bg-hero.jpg 1680w"],
            "sizes": "(max-width: 1060px) 100vw, 1060px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/96797533521002ee15b4f820d07b2740/44a6b/bg-hero.jpg",
            "alt": "summary block bg img",
            "title": "summary block bg img",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "were-ready-to-help"
    }}>{`We're ready to help`}</h3>
    <p>{`Have questions about the Acrobat Services APIs?`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.adobe.com/go/pdftoolsapi_forum"
        }}>{`Go to the Adobe Forum`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../pricing/contact.md"
        }}>{`Contact us`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      